import { useMemo, useState } from 'react'

function useComputed(initialState, ...mapFns) {

	const [state, setState] = useState(initialState)

	const memo = useMemo(() => mapFns.map(mapFn => mapFn(state)), [state])

	return [state, setState, memo]
}

export default useComputed
